<template>
  <div>

    <el-table class="table" size="mini" :data="tableData" :height="th"
              v-loading="loading" ref="table" border >
      <el-table-column prop="goodsName" label="当月服务项目" width="200" fixed></el-table-column>
      <el-table-column prop="number" label="服务次数"></el-table-column>
    </el-table>

  </div>
</template>

<script>

import {timeStr, timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";


export default {
  name: "Page",
  data() {
    return {

      showModal:false,
      showModalInfo:false,

      showModalElderly:false,

      serveOrderPrice:0,


      loading: false,

      tableData: [],
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,

      userCode: '',
      elderlyName:'',
      serveCode:'',
      serveName:'',


      startEndTime:[],

      isDelete:0,
      delete_arr: [
        {value: 0, label: '全部订单'},
        {value: 1, label: '正常订单'},
        {value: 2, label: '已删除订单'},
      ],


      imgUrl: this.$imgUrl,
      th: this.$store.state.tableHeight-180,

      showSum:true,

      zoneValue: [],
      zoneCode: '',
      zoneProps: {
        emitPath: false,
        value: 'zoneCode',
        label: 'name',
        children: 'listZoneDTO'
      },

      arr_business:[],
      businessCode:'',

    }
  },
  components: {

  },
  created() {

  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight': function (val) {
      this.th = val-180;
      this.$nextTick(()=>{
        this.$refs.table.doLayout()
      })
    },
  },
  methods: {

    init(userCode) {
      this.userCode = userCode;
      this.getList();
    },
    getList() {

      var _this=this
      this.loading=true

      let data={
        timeStr:timeStr,
        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
        staffCode: getStaffCode(),
        userCode:this.userCode,
      }

      this.$axios({
        method: 'post',
        url: this.$shopUrl + "OrderBusinessGov/ListServeMonth",
        data: data
      }).then((response) => {

        this.loading = false;

        if (response.data.error === 0) {
          this.tableData = response.data.data.list;
          this.$nextTick(()=>{
            this.$refs.table.doLayout()
          })

        } else if (response.data.error === 1) {
          this.$message.error(response.data.message)
        }

      }).catch(function (error) {
        _this.loading = false;
        console.log(error);
      });

    },


  }
}
</script>


<style lang="scss" scoped>


</style>
